module.exports = __webpack_public_path__ + "static/media/admin.ad327557.png";